module.exports = (__webpack_require__(21))(2347);